const PageLoadingFallback = ({
  label = 'Loading content',
  className = 'flex flex-1 items-center justify-center p-6',
}) => (
  <div className={className} role="status" aria-label={label}>
    <div className="h-6 w-6 animate-spin rounded-full border-2 border-slate-300 border-t-indigo-600" />
  </div>
);

export default PageLoadingFallback;
